import { render, staticRenderFns } from "./MessageListTop.vue?vue&type=template&id=bb4d594e&"
import script from "./MessageListTop.vue?vue&type=script&lang=ts&"
export * from "./MessageListTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports